import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
    EmbeddedTokenModel
} from '../contracts';
import { AppConfig } from '../app.config';

@Injectable()
export class StatisticsService {
    constructor(private readonly http: HttpClient) { }
    public getScreeningsAndRiskAssessments(): Observable<EmbeddedTokenModel> {
        return this.http.get<EmbeddedTokenModel>(AppConfig.apiUrls.statistics.getScreeningsAndRiskAssessments());
    }
    public getLocationScreenings(): Observable<EmbeddedTokenModel> {
        return this.http.get<EmbeddedTokenModel>(AppConfig.apiUrls.statistics.getLocationScreenings());
    }

    public getRiskCalculations(): Observable<EmbeddedTokenModel> {
        return this.http.get<EmbeddedTokenModel>(AppConfig.apiUrls.statistics.getRiskCalculations());
    }
}
